import { ActionTypes } from 'src/types/types';

export const FEATURE_NAME = 'attendees';

export const actionTypes = {
  FETCH_CUSTOMERS: `${FEATURE_NAME}/FETCH_CUSTOMERS`,
  FETCH_ATTENDEES_BY_EVENT: `${FEATURE_NAME}/FETCH_ATTENDEES_BY_EVENT`,
  SEARCH_ATTENDEES_BY_EVENT: `${FEATURE_NAME}/SEARCH_ATTENDEES_BY_EVENT`,
  SEARCH_ATTENDEES_STATS_BY_EVENT: `${FEATURE_NAME}/SEARCH_ATTENDEES_STATS_BY_EVENT`,
  FETCH_EVENT_WAITLIST_ATTENDEES: `${FEATURE_NAME}/FETCH_EVENT_WAITLIST_ATTENDEES`,
  FETCH_ATTENDEES_BY_EVENT_PAGINATION: `${FEATURE_NAME}/FETCH_ATTENDEES_BY_EVENT_PAGINATION`,
  FETCH_WORKFLOWS_BY_CUSTOMER_ID: `${FEATURE_NAME}/FETCH_WORKFLOWS_BY_CUSTOMER_ID`,
  FETCH_ATTENDEE_MONTHLY_TRANSACTIONS: `${FEATURE_NAME}/FETCH_ATTENDEE_MONTHLY_TRANSACTIONS`,
  FETCH_ATTENDEE_DAILY_TRANSACTIONS: `${FEATURE_NAME}/FETCH_ATTENDEE_DAILY_TRANSACTIONS`,
  FETCH_CUSTOMER: `${FEATURE_NAME}/FETCH_CUSTOMER`,
  FETCH_ATTENDEE: `${FEATURE_NAME}/FETCH_ATTENDEE`,
  FETCH_ATTENDEE_BY_EMAIL: `${FEATURE_NAME}/FETCH_ATTENDEE_BY_EMAIL`,
  DELETE_ATTENDEE: `${FEATURE_NAME}/DELETE_ATTENDEE`,
  CREATE_ATTENDEE: `${FEATURE_NAME}/CREATE_ATTENDEE`,
  ADD_ATTENDEE_NOTE: `${FEATURE_NAME}/ADD_ATTENDEE_NOTE`,
  FETCH_ATTENDEE_NOTES: `${FEATURE_NAME}/FETCH_ATTENDEE_NOTES`,
  UPDATE_ATTENDEE: `${FEATURE_NAME}/UPDATE_ATTENDEE`,
  CONVERT_TO_ATTENDEE: `${FEATURE_NAME}/CONVERT_TO_ATTENDEE`,
  UPDATE_ATTENDEE_TICKET: `${FEATURE_NAME}/UPDATE_ATTENDEE_TICKET`,
  CANCEL_AND_REFUND_ATTENDEE: `${FEATURE_NAME}/CANCEL_AND_REFUND_ATTENDEE`,
  UPDATE_CUSTOMER: `${FEATURE_NAME}/UPDATE_CUSTOMER`,
  FETCH_ORDER: `${FEATURE_NAME}/FETCH_ORDER`,
  FETCH_EMAIL_ACTIVITIES: `${FEATURE_NAME}/FETCH_EMAIL_ACTIVITIES`,
  FETCH_ATTENDEE_ACTIVITIES: `${FEATURE_NAME}/FETCH_ATTENDEE_ACTIVITIES`,
  FETCH_ATTENDEE_TICKETS: `${FEATURE_NAME}/FETCH_ATTENDEE_TICKETS`,
  FETCH_TICKET_RECEIPT_PDF: `${FEATURE_NAME}/FETCH_TICKET_RECEIPT_PDF`,
  FETCH_TICKET_PDF: `${FEATURE_NAME}/FETCH_TICKET_PDF`,
  TRANSFER_ATTENDEE_TICKET: `${FEATURE_NAME}/TRANSFER_ATTENDEE_TICKET`,
  TRANSFER_ORDER: `${FEATURE_NAME}/TRANSFER_ORDER`,
  FETCH_CART_REQUESTS: `${FEATURE_NAME}/FETCH_CART_REQUESTS`,
  FETCH_HOST_PENDING_REQUESTS: `${FEATURE_NAME}/FETCH_HOST_PENDING_REQUESTS`,
  UPDATE_REQUEST_STATUS: `${FEATURE_NAME}/UPDATE_REQUEST_STATUS`,
  FETCH_CONTACT_MESSAGES: `${FEATURE_NAME}/FETCH_CONTACT_MESSAGES`,
  REPLY_TO_CONTACT_MESSAGE: `${FEATURE_NAME}/REPLY_TO_CONTACT_MESSAGE`,
} satisfies ActionTypes<typeof FEATURE_NAME>;
